import React, { useMemo } from 'react'
import {
  ThankYouNote,
  normalizeBenefactorAttributions,
  useBenefactorAttribution,
  useDirectImpact,
} from '@/services/ImpactService'
import { PifAttribution } from '@/types/codegen-federation'
import { ReactFCC } from '@/types/react'

interface ImpactContextProps {
  children: React.ReactNode
}

interface ImpactContextType {
  directImpact?: {
    totalPeople: number
    peopleByCountry: {
      count: number
      country: string
    }[]
  }
  loading: boolean
  thankYouNotes?: {
    edges: ThankYouNote[]
  }
  benefactorAttributions?: PifAttribution[]
}

const ImpactContext = React.createContext<ImpactContextType>({
  directImpact: undefined,
  loading: false,
  thankYouNotes: undefined,
  benefactorAttributions: undefined,
})

export const ImpactContextProvider: ReactFCC<ImpactContextProps> = ({ children }) => {
  const { data: directImpactData, loading: loadingDirectImpact } = useDirectImpact()
  const { data: attributionBenefactorData, loading: loadingBenefactorAttribution } = useBenefactorAttribution()

  const value = {
    directImpact: directImpactData?.directImpact,
    loading: loadingDirectImpact || loadingBenefactorAttribution,
    benefactorAttributions: useMemo(
      () =>
        normalizeBenefactorAttributions({
          attributionBenefactorData,
          loadingBenefactorAttribution,
        }),
      [attributionBenefactorData, loadingBenefactorAttribution],
    ),
  }

  return <ImpactContext.Provider value={value}>{children}</ImpactContext.Provider>
}

export function useImpactContext() {
  return React.useContext(ImpactContext)
}
